import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as $ from "jquery";
import * as _ from "lodash";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import swal from "sweetalert2";
import * as fromRootStore from "../../reducers";
// import { SalesInvoiceService } from "../../../services/salesinvoice.service";
import { Combo2Service, WorkOrderService, PurchaseOrderService } from "../../services/index";
@Component({
  selector: "addEditInvoice",
  templateUrl: "./addProductionListMaster.html",
})
export class addProductionListMaster {
  @ViewChild("tbody1") tbody1;
  row: any;
  data: any;
  designdata: any = { indent_no: 0, totalmtr: 0, totalamt: 0 };


  codeList: any;
  seasonList: any;

  execApi: boolean = true;

  invoicedata: any = {};
  delPartyList: any;
  party_id: any;
  box: any;
  desData: any = {
    totalmtr: 0,
    totalamt: 0,
  };
  designList: any;
  invalidList: any = [];
  colorList: any = [];
  qualityList: any = [];
  fabColorlist: any = [];
  fabColorTemplist: any = [];
  invoiceTypeList = [""];
  rateTypeList = [""];
  mode: string;
  saveEvent: any;
  agentList: any;
  bl = [];
  partyCodeList: any;
  isLoading: boolean = false;
  isChecked: boolean = false;
  sampleList = [{ name: "YES" }, { name: "NO" }];

  partyList: any = [];
  partList = [""];
  typesList = ["FRONT","COLLAR"];
  partyOrderno: any;
  order: any;
  sale_type: any;
  expand = true;
  upd_type: any;
  listSelected = [];
  isLoadMask: Promise<any>;
  @Input() _params: any;
  widtlist: any;

  @Input() set params(val: any[]) {
    this._params = val;
    this.mode = val["mode"];
    this.widtlist = val["data"].widtlist;
    this.sale_type = val["sale_type"];
    this.upd_type = val["upd_type"];
    this.saveEvent = val["data"].tabevent;
    let invoicedata = Object.assign({}, val["data"]);
    this.invoicedata = invoicedata;
    console.log(this.mode, this.upd_type);
    if (this.mode == "Convert") {
      this.invoicedata.mode = "Add";
    }

    if (this.mode == "Convert") {
      //  this.editInvoiceList();
      this.invoicedata.dcdt = this.datePipe.transform(new Date(), "yyyy-MM-dd");
      //   this.oncheck(this.invoicedata.salesorder);
    }
    if (this.mode == "View" || this.mode == "Edit") {

      console.log(this.invoicedata, this.upd_type);
      //    this.invoicedata.dcdt = this.datePipe.transform(new Date(), 'yyyy-MM-dd');
    }
  }

  get params(): any[] {
    return this._params;
  }
  @Output() tabUpdateEvent = new EventEmitter();
  @ViewChild("widthAuto") widthAuto;
  @ViewChild("codeAuto") codeAuto;
  widthCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  OrderNoCtrl: FormControl = new FormControl();
  qualityCtrl: FormControl = new FormControl();
  invdtControl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  constructor(
    public store: Store<fromRootStore.State>,
    private salesinvservice: WorkOrderService,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: PurchaseOrderService

  ) {
   
    this.data = {
      invoiceList: [],
    };
  }
  ngOnInit() {
    this.tableScroll();
    this.invoicedata.mode = this.mode;

  }
  ngAfterViewInit() {
    $("#invoice_type").focus();
  }
  tableScroll() {
    $(".invoiceTable").height(window.innerHeight - 400);
    $(".invoiceTable").width(window.innerWidth - 30);
  }

  OnselectpartyId(type){
   let temp = this.partyList.filter(el=>el.code == type);
   this.invoicedata.party_id = temp[0].party_id;


  }
  buttonStyle() {
    const style = {
     Position : "relative",
      left: this.mode == "Add" ? "60%" : "58%",
      bottom: "54px"
    };
    return style;
  }

  addPlainDetails() {

    // if(this.data.invoiceList.find(x=>x.width.trim() == this.invoicedata.width && x.style.trim() == this.invoicedata.style&& x.variety.trim() == this.invoicedata.variety)
    // ||this.widtlist.find(x=>x.width.trim() == this.invoicedata.width && x.style.trim() == this.invoicedata.style&& x.variety.trim() == this.invoicedata.variety))
    
    // {
    //   swal("SAME COMBINATION ALREADY EXIST");
    //   return;
    // }
    // this.objdata.username = "";
    // this.objdata.password = "";
    // this.objdata.fullname = "";
    // this.objdata.status = "Active";
    // this.userDetails.push({ ...this.objdata });
  
    delete this.invoicedata.tabevent;
    this.data.invoiceList.push({...this.invoicedata});
    console.log(this.data.invoiceList);
    var bottom = document.querySelector("#salesTbody");
    setTimeout(() => {
      bottom.scrollTop = bottom.scrollHeight;
    }, 300);

    // this.invoicedata = new Object();
       this.invoicedata.part = '';

  }
  onEnterKeyPressed(nextEl: string) {

 
      // let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      // a.removeClass("mat-autocomplete-visible");
      // $("#" + nextEl).focus();
      setTimeout(() => {
        $("#" + nextEl).focus();
      }, 100);
    

  }

  onDeleteRow($event, fld, ind) {
    $event.preventDefault();
    let that = this;
    swal({
      title: "Are you sure to delete this row?",
      type: "warning",
      focusCancel: true,
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      cancelButtonText: "No, want to change",
    }).then(
      function () {
        if (that.data.invoiceList.length >= 1) {

          that.data.invoiceList.splice(ind, 1);

          if ($("#" + this.page_id + fld + "-" + (ind - 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind - 1)).focus();
          } else if ($("#" + this.page_id + fld + "-" + (ind + 1)).length > 0) {
            $("#" + this.page_id + fld + "-" + (ind + 1)).focus();
          }
        }
      },
      function (dismiss) { }
    );
  }
  checkAll(evant, all) {
    if (evant.target.checked) {
      this.listSelected = this.data.invoiceList;
      $("input:checkbox").prop("checked", evant.target.checked);
    } else {
      $("input:checkbox").prop("checked", evant.target.checked);
      this.listSelected = [];
    }
  }


  onGoToUpAndDown($event, fld, arrow, ind) {
    if ($(".mat-autocomplete-panel.mat-autocomplete-visible").length > 0) {
      return false;
    }
    $event.preventDefault();
    if ($("typeahead-container").length > 0) {
      return false;
    }
    if (arrow == "up") ind--;
    else ind++;

    if ($("#" + fld + "-" + ind).length > 0) {
      $("#" + fld + "-" + ind).focus();
    }
  }

  // getAutoNumber() {

  //   this.salesinvservice.getMultiFabAuto({}).then((res: any) => {
  //     this.invoicedata.ref_no = res;
  //   });
  // }


  getTbodyStyle() {
    let height = 300;
    if (this.tbody1) {
      height -= this.tbody1.nativeElement.offsetHeight;
    }
    const style = {
      display: "block",
      width: "1px",
      height: height + "px",
      "overflow-y": "scroll",
    };
    return style;
  }

  oncheckemptyrow(){
   
    let params: any = Object.assign({}, this.invoicedata);
    params["tabevent"] = undefined;
    params["data"] = JSON.stringify(this.data.invoiceList);
    let that = this;

    swal({
      title: "Are you sure to save this Changes?",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, save it!",
      cancelButtonText: "No, want to change",
    }).then(function () {
      that.isLoadMask = that.salesinvservice
        .saveProductionMasterDetails(params)
        .then(function (res: any) {
          if (that.saveEvent) {
            that.saveEvent.emit();
          }
          if (res.success) {
            that.toasterService.pop({
              bodyOutputType: 1,
              type: "success",
              title: "SUCCESS",
              body: res.message,
            });
            if (that.mode == "Add") {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            } else {
              let tabObj = {
                action: "CloseTab",
                params: {},
              };
              that.tabUpdateEvent.emit(tabObj);
            }
          }
          else {
            swal("This Design" +" " + res.message);
          }
        })
        .catch(function (error: any) {
          let res = JSON.parse(error._body);
          swal("ERROR", res.message, "error");
        });
    });
 
}
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/master/addProductionListMaster.ts